export default __webpack_public_path__ + "static/media/clear.067fd351.svg";